export default __webpack_public_path__ + "5815df498dde433e5f4dabcdd109fa3f.png";